import React from 'react';

import { BsSearch } from "react-icons/bs";
import { Player } from 'video-react';

import orangeRing from './../../assets/images/static/orange_Ring.png';
import poster from './../../assets/images/static/loginBg.jpg';
import VideoCarousel from './VideoCarousel/VideoCarosel';

import {
  StyledTutorialSection,
  StyledHeroSection,
  HeadingSection,
  HeadingTitle,
  Strong,
  SubTitle,
  SearchSection,
  SearchInput,
  RingIllustration,
  VideoWrapper,
  StyledVideo,
  CaptionTitle,
} from './styled';

const Tutorials = () => {
  return (
    <StyledTutorialSection>
      <StyledHeroSection>
        <HeadingSection>
          <SubTitle>Videos</SubTitle>
          <HeadingTitle>How E-Retail <Strong>Works</Strong></HeadingTitle>
          <SubTitle className='hideonMobile'>Our product tutorials</SubTitle>
          <SearchSection>
            <BsSearch />
            <SearchInput placeholder='Search Video Here' />
          </SearchSection>
        </HeadingSection>
        <RingIllustration 
          src={orangeRing} 
          alt="Ring Illustration"
          className='hideonMobile'
        />
      </StyledHeroSection>
      <VideoWrapper>
        <StyledVideo>
          <Player
            playsInline
            poster={poster}
            src="https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4"
          />
        </StyledVideo>
        <CaptionTitle>E-Retail Point is a point-of-sale (POS) solution where you can manage all of your business's administrative,</CaptionTitle>
      </VideoWrapper>
      <VideoCarousel />
    </StyledTutorialSection>
  )
}

export default Tutorials;